<template>
  <v-container fluid>
    <div class="modal-padding">
      <v-row>
        <v-col cols="6" sm="6" class="zero-top">
          <div class="show-drop-down">
            <div class="label-data">Select Center(s)</div>
            <div class="field-data" id="scroll-top" >
              <multi-select
                id="scroll-top-center"
                allText="All Centers"
                :items="centers"
				        ref="center"
                :updateScrollerFlag="updateScrollerFlag"
                label="select center"
                :onChange="onCenterchange"
                widthcss="fix-width-200"
              ></multi-select>
            </div>
          </div>
        </v-col>
        <v-col cols="6" sm="6" class="zero-top">
          <div class="show-drop-down">
            <div class="label-data">Select Batch(es)</div>
            <div class="field-data" >
              <multi-select
                :updateScrollerFlag="updateScrollerFlag"
                allText="All Batches"
                :items="batches"
				        ref="batch"
                label="select batch"
                :onChange="onBatchSelect"
                widthcss="fix-width-200"
              ></multi-select>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="12" class="zero-top">
          <!-- <v-textarea label="Message:" class="textarea-msg" value="Lorem Ipsum Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts of Cicero's De Finibus Bonorum etge is attributed to an unknown types Malorum for use in a type specimen book" rows="4" dense outlined hide-details no-resize></v-textarea> -->
          <div class="ck-editor">
            <ckeditor
              @focus="onFocus"
			  @click="onFocus"
              :editorUrl="editorURL"
              v-model="editorData"
              :config="{ toolbarStartupExpanded: false, startupFocus: true }"
            ></ckeditor>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <div class="right-align yes-no-block">
            <v-btn
              @click="onClose({ status: false })"
              class="right-btn cust-btn"
              color="primary"
              >Discard</v-btn
            >
            <v-btn
              @click="requestSendMessage"
              class="right-btn cust-btn no-btn"
              color="primary"
              >Send</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import debounce from "debounce";
const user = JSON.parse(sessionStorage.getItem("user"));
import constants from "@/utils/constants.js";

export default {
  name: "BroadcastMessage",
  props: ["onClose", "status", "showLoader"],
  data() {
    return {
      autoUpdate: true,
      selectedCenterId: [],
      selectedBatch: [],
      editorData: "",
      centers: [],
      batches: [],
      loadingPersons: false,
      search: "",
      isLoadingFirstTime: true,
      updateScrollerFlag: false,
    };
  },
  mounted() {
    this.getCentersCall();
    
  },
  watch: {
    selectedUsers(val) {
      this.search = "";
    },
    search(value) {
      if (!value) {
        return;
      }
      // Debounce the input and wait for a pause of at
      // least 200 milliseconds. This can be changed to
      // suit your needs.
      debounce(this.makeSearch, 200)(value, this);
    },
    status(val) {
      if (!val) {
        this.selectedUsers = [];
        this.editorData = "";
        this.people = [];
      }
      /*else {
        this.$refs.center.updateScroll();
      }*/
    },
    data(val) {
      this.selectedUsers = val.map((r) => {
        return r.username;
      });

      this.people = val;
    },
    /*selectedCenters(val)
    {
      let me = this;
       setTimeout(()=> {
            me.updateScroll();
        }, 100);
      
    },*/
  },

  methods: {
    ...mapActions({
      broadcastMessage: "messageStore/broadcastMessage",
      getCenters: "centerAndBatchStore/getCenters",
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      getBatches: "centerAndBatchStore/getBatches",
    }),
	onFocus(){
		this.$refs.center.setMenuModal();
		this.$refs.batch.setMenuModal();
	},
    onCenterchange(centerIds) {
      this.selectedCenterId = centerIds;

      this.batches = [];
      if (centerIds.length)
        this.getBatches({ center_id: centerIds })
          .then((response) => {
            this.batches = response.list.map((x) => {
              let c = {};
              c.text = x.name;
              c.value = x.id;
              return c;
            });
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getCentersFunction() {
      if (user && user.role_id === constants.ROLES_ID.CO) {
        return "getCentersByUser";
      }
      return "getCenters";
    },
    getCentersCall() {
      this[this.getCentersFunction()]({ orderBy: this.orderByForCenter })
        .then((response) => {
          this.centers = response.map((x) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
          });
          // this.centers = this.centers.filter((c) => {
          //   return this.alreadySelectedCenter.indexOf(c.value) === -1;
          // });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onBatchSelect(selectedBatch) {
      if (!this.isLoadingFirstTime) this.resetPage();
      this.selectedBatch = selectedBatch;
    },
    requestSendMessage() {
      if (!this.selectedCenterId.length && !this.selectedBatch.length) {
        return this.$toasted.error(
          "Please select centers/batches to broadcast message."
        );
      } else if (
        !this.editorData ||
        this.extractContent(this.editorData, true).trim().length < 1
      ) {
        return this.$toasted.error("Please add message");
      }
      let reqData = {
        message: this.editorData,
      };
      if (this.selectedBatch.length) {
        reqData.batch_id = this.selectedBatch;
      } else {
        reqData.center_id = this.selectedCenterId;
      }
      this.showLoader(true);
      this.broadcastMessage(reqData)
        .then((response) => {
          this.showLoader(false);
          this.onClose({ status: false, realodMessage: true });
          this.$toasted.success(`Success\n${response.message}`, {
            icon: "check_circle",
          });
          this.updateScrollerFlag = true;
          this.selectedBatch = [];
          this.selectedCenterId = [];
          this.batches = [];
          this.getCentersCall();
        })
        .catch((err) => {
          console.log(err);
          this.showLoader(false);
        });
    },
    updateScroll(){
      var el = document.querySelector('#scroll-top-center');
      el.scrollIntoView();
   },
  },
};
</script>